/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DeleteProjectCharacterParams,
  PostProjectIdMembersParams,
  ProjectCatalogDto,
  ProjectDto,
  ProjectMemberDto,
  PutProjectCharacterParams,
  PutProjectIdMembersUserIdRoleParams,
} from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Find All
 */
export const getProject = (signal?: AbortSignal) => {
  return customInstance<ProjectDto[]>({
    url: `/project`,
    method: "GET",
    signal,
  });
};

export const getGetProjectInfiniteQueryKey = () => {
  return ["infinite", `/project`] as const;
};

export const getGetProjectQueryKey = () => {
  return [`/project`] as const;
};

export const getGetProjectInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getProject>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getProject>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProject>>> = ({
    signal,
  }) => getProject(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getProject>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProject>>
>;
export type GetProjectInfiniteQueryError = void;

export function useGetProjectInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProject>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProject>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProject>>,
          TError,
          Awaited<ReturnType<typeof getProject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProjectInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProject>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProject>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProject>>,
          TError,
          Awaited<ReturnType<typeof getProject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProjectInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProject>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find All
 */

export function useGetProjectInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProject>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProjectInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetProjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getProject>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProject>>> = ({
    signal,
  }) => getProject(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProject>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProject>>
>;
export type GetProjectQueryError = void;

export function useGetProject<
  TData = Awaited<ReturnType<typeof getProject>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProject>>,
          TError,
          Awaited<ReturnType<typeof getProject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProject<
  TData = Awaited<ReturnType<typeof getProject>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProject>>,
          TError,
          Awaited<ReturnType<typeof getProject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProject<
  TData = Awaited<ReturnType<typeof getProject>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find All
 */

export function useGetProject<
  TData = Awaited<ReturnType<typeof getProject>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProjectQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create
 */
export const postProject = (projectDto: ProjectDto, signal?: AbortSignal) => {
  return customInstance<ProjectDto>({
    url: `/project`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: projectDto,
    signal,
  });
};

export const getPostProjectMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postProject>>,
    TError,
    { data: ProjectDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postProject>>,
  TError,
  { data: ProjectDto },
  TContext
> => {
  const mutationKey = ["postProject"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postProject>>,
    { data: ProjectDto }
  > = (props) => {
    const { data } = props ?? {};

    return postProject(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof postProject>>
>;
export type PostProjectMutationBody = ProjectDto;
export type PostProjectMutationError = void;

/**
 * @summary Create
 */
export const usePostProject = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postProject>>,
      TError,
      { data: ProjectDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postProject>>,
  TError,
  { data: ProjectDto },
  TContext
> => {
  const mutationOptions = getPostProjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Available Projects From Catalog
 */
export const getProjectAvailableProjects = (signal?: AbortSignal) => {
  return customInstance<ProjectCatalogDto[]>({
    url: `/project/available-projects`,
    method: "GET",
    signal,
  });
};

export const getGetProjectAvailableProjectsInfiniteQueryKey = () => {
  return ["infinite", `/project/available-projects`] as const;
};

export const getGetProjectAvailableProjectsQueryKey = () => {
  return [`/project/available-projects`] as const;
};

export const getGetProjectAvailableProjectsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectAvailableProjects>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getProjectAvailableProjects>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetProjectAvailableProjectsInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProjectAvailableProjects>>
  > = ({ signal }) => getProjectAvailableProjects(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getProjectAvailableProjects>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectAvailableProjectsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectAvailableProjects>>
>;
export type GetProjectAvailableProjectsInfiniteQueryError = void;

export function useGetProjectAvailableProjectsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectAvailableProjects>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProjectAvailableProjects>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectAvailableProjects>>,
          TError,
          Awaited<ReturnType<typeof getProjectAvailableProjects>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProjectAvailableProjectsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectAvailableProjects>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProjectAvailableProjects>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectAvailableProjects>>,
          TError,
          Awaited<ReturnType<typeof getProjectAvailableProjects>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProjectAvailableProjectsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectAvailableProjects>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProjectAvailableProjects>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Available Projects From Catalog
 */

export function useGetProjectAvailableProjectsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectAvailableProjects>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProjectAvailableProjects>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetProjectAvailableProjectsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetProjectAvailableProjectsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectAvailableProjects>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getProjectAvailableProjects>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetProjectAvailableProjectsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProjectAvailableProjects>>
  > = ({ signal }) => getProjectAvailableProjects(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectAvailableProjects>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectAvailableProjectsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectAvailableProjects>>
>;
export type GetProjectAvailableProjectsQueryError = void;

export function useGetProjectAvailableProjects<
  TData = Awaited<ReturnType<typeof getProjectAvailableProjects>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProjectAvailableProjects>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectAvailableProjects>>,
          TError,
          Awaited<ReturnType<typeof getProjectAvailableProjects>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProjectAvailableProjects<
  TData = Awaited<ReturnType<typeof getProjectAvailableProjects>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProjectAvailableProjects>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectAvailableProjects>>,
          TError,
          Awaited<ReturnType<typeof getProjectAvailableProjects>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProjectAvailableProjects<
  TData = Awaited<ReturnType<typeof getProjectAvailableProjects>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProjectAvailableProjects>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Available Projects From Catalog
 */

export function useGetProjectAvailableProjects<
  TData = Awaited<ReturnType<typeof getProjectAvailableProjects>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProjectAvailableProjects>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProjectAvailableProjectsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Remove Character
 */
export const deleteProjectCharacter = (
  params?: DeleteProjectCharacterParams,
) => {
  return customInstance<ProjectDto>({
    url: `/project/character`,
    method: "DELETE",
    params,
  });
};

export const getDeleteProjectCharacterMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProjectCharacter>>,
    TError,
    { params?: DeleteProjectCharacterParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProjectCharacter>>,
  TError,
  { params?: DeleteProjectCharacterParams },
  TContext
> => {
  const mutationKey = ["deleteProjectCharacter"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProjectCharacter>>,
    { params?: DeleteProjectCharacterParams }
  > = (props) => {
    const { params } = props ?? {};

    return deleteProjectCharacter(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProjectCharacterMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProjectCharacter>>
>;

export type DeleteProjectCharacterMutationError = void;

/**
 * @summary Remove Character
 */
export const useDeleteProjectCharacter = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteProjectCharacter>>,
      TError,
      { params?: DeleteProjectCharacterParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteProjectCharacter>>,
  TError,
  { params?: DeleteProjectCharacterParams },
  TContext
> => {
  const mutationOptions = getDeleteProjectCharacterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Add Character
 */
export const putProjectCharacter = (params?: PutProjectCharacterParams) => {
  return customInstance<ProjectDto>({
    url: `/project/character`,
    method: "PUT",
    params,
  });
};

export const getPutProjectCharacterMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putProjectCharacter>>,
    TError,
    { params?: PutProjectCharacterParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putProjectCharacter>>,
  TError,
  { params?: PutProjectCharacterParams },
  TContext
> => {
  const mutationKey = ["putProjectCharacter"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putProjectCharacter>>,
    { params?: PutProjectCharacterParams }
  > = (props) => {
    const { params } = props ?? {};

    return putProjectCharacter(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutProjectCharacterMutationResult = NonNullable<
  Awaited<ReturnType<typeof putProjectCharacter>>
>;

export type PutProjectCharacterMutationError = void;

/**
 * @summary Add Character
 */
export const usePutProjectCharacter = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putProjectCharacter>>,
      TError,
      { params?: PutProjectCharacterParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putProjectCharacter>>,
  TError,
  { params?: PutProjectCharacterParams },
  TContext
> => {
  const mutationOptions = getPutProjectCharacterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update
 */
export const putProjectId = (id: number, projectDto: ProjectDto) => {
  return customInstance<ProjectDto>({
    url: `/project/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: projectDto,
  });
};

export const getPutProjectIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putProjectId>>,
    TError,
    { id: number; data: ProjectDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putProjectId>>,
  TError,
  { id: number; data: ProjectDto },
  TContext
> => {
  const mutationKey = ["putProjectId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putProjectId>>,
    { id: number; data: ProjectDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return putProjectId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutProjectIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putProjectId>>
>;
export type PutProjectIdMutationBody = ProjectDto;
export type PutProjectIdMutationError = void;

/**
 * @summary Update
 */
export const usePutProjectId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putProjectId>>,
      TError,
      { id: number; data: ProjectDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putProjectId>>,
  TError,
  { id: number; data: ProjectDto },
  TContext
> => {
  const mutationOptions = getPutProjectIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Find By Id
 */
export const getProjectId = (id: number, signal?: AbortSignal) => {
  return customInstance<ProjectDto>({
    url: `/project/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetProjectIdInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/project/${id}`] as const;
};

export const getGetProjectIdQueryKey = (id?: number) => {
  return [`/project/${id}`] as const;
};

export const getGetProjectIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProjectId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetProjectIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectId>>> = ({
    signal,
  }) => getProjectId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getProjectId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectId>>
>;
export type GetProjectIdInfiniteQueryError = void;

export function useGetProjectIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectId>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectId>>,
          TError,
          Awaited<ReturnType<typeof getProjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProjectIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectId>>,
          TError,
          Awaited<ReturnType<typeof getProjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProjectIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find By Id
 */

export function useGetProjectIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProjectIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetProjectIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectId>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectId>>> = ({
    signal,
  }) => getProjectId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectId>>
>;
export type GetProjectIdQueryError = void;

export function useGetProjectId<
  TData = Awaited<ReturnType<typeof getProjectId>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectId>>,
          TError,
          Awaited<ReturnType<typeof getProjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProjectId<
  TData = Awaited<ReturnType<typeof getProjectId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectId>>,
          TError,
          Awaited<ReturnType<typeof getProjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProjectId<
  TData = Awaited<ReturnType<typeof getProjectId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find By Id
 */

export function useGetProjectId<
  TData = Awaited<ReturnType<typeof getProjectId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProjectIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete
 */
export const deleteProjectId = (id: number) => {
  return customInstance<boolean>({ url: `/project/${id}`, method: "DELETE" });
};

export const getDeleteProjectIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProjectId>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProjectId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteProjectId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProjectId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteProjectId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProjectIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProjectId>>
>;

export type DeleteProjectIdMutationError = void;

/**
 * @summary Delete
 */
export const useDeleteProjectId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteProjectId>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteProjectId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteProjectIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Members
 */
export const getProjectIdMembers = (id: number, signal?: AbortSignal) => {
  return customInstance<ProjectMemberDto[]>({
    url: `/project/${id}/members`,
    method: "GET",
    signal,
  });
};

export const getGetProjectIdMembersInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/project/${id}/members`] as const;
};

export const getGetProjectIdMembersQueryKey = (id?: number) => {
  return [`/project/${id}/members`] as const;
};

export const getGetProjectIdMembersInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectIdMembers>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProjectIdMembers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetProjectIdMembersInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProjectIdMembers>>
  > = ({ signal }) => getProjectIdMembers(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getProjectIdMembers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectIdMembersInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectIdMembers>>
>;
export type GetProjectIdMembersInfiniteQueryError = void;

export function useGetProjectIdMembersInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectIdMembers>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProjectIdMembers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectIdMembers>>,
          TError,
          Awaited<ReturnType<typeof getProjectIdMembers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProjectIdMembersInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectIdMembers>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProjectIdMembers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectIdMembers>>,
          TError,
          Awaited<ReturnType<typeof getProjectIdMembers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProjectIdMembersInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectIdMembers>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProjectIdMembers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Members
 */

export function useGetProjectIdMembersInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectIdMembers>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProjectIdMembers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProjectIdMembersInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetProjectIdMembersQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectIdMembers>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProjectIdMembers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectIdMembersQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProjectIdMembers>>
  > = ({ signal }) => getProjectIdMembers(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectIdMembers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectIdMembersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectIdMembers>>
>;
export type GetProjectIdMembersQueryError = void;

export function useGetProjectIdMembers<
  TData = Awaited<ReturnType<typeof getProjectIdMembers>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProjectIdMembers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectIdMembers>>,
          TError,
          Awaited<ReturnType<typeof getProjectIdMembers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProjectIdMembers<
  TData = Awaited<ReturnType<typeof getProjectIdMembers>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProjectIdMembers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectIdMembers>>,
          TError,
          Awaited<ReturnType<typeof getProjectIdMembers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProjectIdMembers<
  TData = Awaited<ReturnType<typeof getProjectIdMembers>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProjectIdMembers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Members
 */

export function useGetProjectIdMembers<
  TData = Awaited<ReturnType<typeof getProjectIdMembers>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProjectIdMembers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProjectIdMembersQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add Member
 */
export const postProjectIdMembers = (
  id: number,
  params?: PostProjectIdMembersParams,
  signal?: AbortSignal,
) => {
  return customInstance<ProjectMemberDto>({
    url: `/project/${id}/members`,
    method: "POST",
    params,
    signal,
  });
};

export const getPostProjectIdMembersMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postProjectIdMembers>>,
    TError,
    { id: number; params?: PostProjectIdMembersParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postProjectIdMembers>>,
  TError,
  { id: number; params?: PostProjectIdMembersParams },
  TContext
> => {
  const mutationKey = ["postProjectIdMembers"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postProjectIdMembers>>,
    { id: number; params?: PostProjectIdMembersParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return postProjectIdMembers(id, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostProjectIdMembersMutationResult = NonNullable<
  Awaited<ReturnType<typeof postProjectIdMembers>>
>;

export type PostProjectIdMembersMutationError = void;

/**
 * @summary Add Member
 */
export const usePostProjectIdMembers = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postProjectIdMembers>>,
      TError,
      { id: number; params?: PostProjectIdMembersParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postProjectIdMembers>>,
  TError,
  { id: number; params?: PostProjectIdMembersParams },
  TContext
> => {
  const mutationOptions = getPostProjectIdMembersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Remove Member
 */
export const deleteProjectIdMembersUserId = (id: number, userId: number) => {
  return customInstance<boolean>({
    url: `/project/${id}/members/${userId}`,
    method: "DELETE",
  });
};

export const getDeleteProjectIdMembersUserIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProjectIdMembersUserId>>,
    TError,
    { id: number; userId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProjectIdMembersUserId>>,
  TError,
  { id: number; userId: number },
  TContext
> => {
  const mutationKey = ["deleteProjectIdMembersUserId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProjectIdMembersUserId>>,
    { id: number; userId: number }
  > = (props) => {
    const { id, userId } = props ?? {};

    return deleteProjectIdMembersUserId(id, userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProjectIdMembersUserIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProjectIdMembersUserId>>
>;

export type DeleteProjectIdMembersUserIdMutationError = void;

/**
 * @summary Remove Member
 */
export const useDeleteProjectIdMembersUserId = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteProjectIdMembersUserId>>,
      TError,
      { id: number; userId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteProjectIdMembersUserId>>,
  TError,
  { id: number; userId: number },
  TContext
> => {
  const mutationOptions =
    getDeleteProjectIdMembersUserIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Set Member Role
 */
export const putProjectIdMembersUserIdRole = (
  id: number,
  userId: number,
  params?: PutProjectIdMembersUserIdRoleParams,
) => {
  return customInstance<ProjectMemberDto>({
    url: `/project/${id}/members/${userId}/role`,
    method: "PUT",
    params,
  });
};

export const getPutProjectIdMembersUserIdRoleMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putProjectIdMembersUserIdRole>>,
    TError,
    {
      id: number;
      userId: number;
      params?: PutProjectIdMembersUserIdRoleParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putProjectIdMembersUserIdRole>>,
  TError,
  { id: number; userId: number; params?: PutProjectIdMembersUserIdRoleParams },
  TContext
> => {
  const mutationKey = ["putProjectIdMembersUserIdRole"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putProjectIdMembersUserIdRole>>,
    { id: number; userId: number; params?: PutProjectIdMembersUserIdRoleParams }
  > = (props) => {
    const { id, userId, params } = props ?? {};

    return putProjectIdMembersUserIdRole(id, userId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutProjectIdMembersUserIdRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof putProjectIdMembersUserIdRole>>
>;

export type PutProjectIdMembersUserIdRoleMutationError = void;

/**
 * @summary Set Member Role
 */
export const usePutProjectIdMembersUserIdRole = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putProjectIdMembersUserIdRole>>,
      TError,
      {
        id: number;
        userId: number;
        params?: PutProjectIdMembersUserIdRoleParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putProjectIdMembersUserIdRole>>,
  TError,
  { id: number; userId: number; params?: PutProjectIdMembersUserIdRoleParams },
  TContext
> => {
  const mutationOptions =
    getPutProjectIdMembersUserIdRoleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Find By Name
 */
export const getProjectNameName = (name: string, signal?: AbortSignal) => {
  return customInstance<ProjectDto>({
    url: `/project/${name}/name`,
    method: "GET",
    signal,
  });
};

export const getGetProjectNameNameInfiniteQueryKey = (name?: string) => {
  return ["infinite", `/project/${name}/name`] as const;
};

export const getGetProjectNameNameQueryKey = (name?: string) => {
  return [`/project/${name}/name`] as const;
};

export const getGetProjectNameNameInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectNameName>>>,
  TError = void,
>(
  name: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProjectNameName>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetProjectNameNameInfiniteQueryKey(name);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProjectNameName>>
  > = ({ signal }) => getProjectNameName(name, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!name,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getProjectNameName>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectNameNameInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectNameName>>
>;
export type GetProjectNameNameInfiniteQueryError = void;

export function useGetProjectNameNameInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectNameName>>>,
  TError = void,
>(
  name: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProjectNameName>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectNameName>>,
          TError,
          Awaited<ReturnType<typeof getProjectNameName>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProjectNameNameInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectNameName>>>,
  TError = void,
>(
  name: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProjectNameName>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectNameName>>,
          TError,
          Awaited<ReturnType<typeof getProjectNameName>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProjectNameNameInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectNameName>>>,
  TError = void,
>(
  name: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProjectNameName>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find By Name
 */

export function useGetProjectNameNameInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectNameName>>>,
  TError = void,
>(
  name: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getProjectNameName>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProjectNameNameInfiniteQueryOptions(name, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetProjectNameNameQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectNameName>>,
  TError = void,
>(
  name: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProjectNameName>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetProjectNameNameQueryKey(name);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProjectNameName>>
  > = ({ signal }) => getProjectNameName(name, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!name,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectNameName>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectNameNameQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectNameName>>
>;
export type GetProjectNameNameQueryError = void;

export function useGetProjectNameName<
  TData = Awaited<ReturnType<typeof getProjectNameName>>,
  TError = void,
>(
  name: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProjectNameName>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectNameName>>,
          TError,
          Awaited<ReturnType<typeof getProjectNameName>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProjectNameName<
  TData = Awaited<ReturnType<typeof getProjectNameName>>,
  TError = void,
>(
  name: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProjectNameName>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectNameName>>,
          TError,
          Awaited<ReturnType<typeof getProjectNameName>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProjectNameName<
  TData = Awaited<ReturnType<typeof getProjectNameName>>,
  TError = void,
>(
  name: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProjectNameName>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find By Name
 */

export function useGetProjectNameName<
  TData = Awaited<ReturnType<typeof getProjectNameName>>,
  TError = void,
>(
  name: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProjectNameName>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProjectNameNameQueryOptions(name, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
